import { put } from 'redux-saga/effects';
import { push } from 'react-router-redux';

import store from '../store';
import * as endpoint from 'misc/endpoint';
import * as types from 'misc/types';

export function* archiveEnvelope(action) {
    try {
        let put_url = 'envelopes/' + action.envelopeId;

        action.state.archived = true;

        const response = yield endpoint.put(put_url, { state: action.state });
        yield put({ type: types.SAGA_ENVELOPE_ARCHIVE.SUCCESS, payload: response.data });
     
        let envelopes_inbox = store.getState().envelopes_inbox;
        let envelopeToArchive = envelopes_inbox.data.find(e => e.id === action.envelopeId);
        envelopeToArchive.state = action.state;
        envelopeToArchive.hide = true;
        
        yield put({ type: types.SAGA_ENVELOPES_INBOX_GET.SUCCESS, payload: envelopes_inbox.data });
        
        yield put(push('/inbox/'));
    } catch (error) {
        yield put({ type: types.SAGA_ENVELOPE_ARCHIVE.FAILURE, error });
    }
}

export function* deleteEnvelope(action) {
    try {
        // Hemligt meddelande till Erik: tjoho!
        
        let delete_url = 'envelopes/' + action.envelopeId;

        const response = yield endpoint.remove(delete_url);
        yield put({ type: types.SAGA_ENVELOPE_DELETE.SUCCESS, payload: response.data });
       
        if(action.view === 'archives'){
            let search_results = store.getState().search_results;
            let envelopeToDelete = search_results.data.results.find(e => e.id === action.envelopeId);
            envelopeToDelete.hide = true;
    
            yield put({ type: types.SAGA_ARCHIVES_SEARCH_GET.SUCCESS, payload: search_results.data });
            yield put(push('/archives/'));
        }else{
            let envelopes_inbox = store.getState().envelopes_inbox;
            let envelopeToDelete = envelopes_inbox.data.find(e => e.id === action.envelopeId);
            envelopeToDelete.hide = true;

            yield put({ type: types.SAGA_ENVELOPES_INBOX_GET.SUCCESS, payload: envelopes_inbox.data });
            yield put(push('/inbox/'));
        }
    } catch (error) {
        yield put({ type: types.SAGA_ENVELOPE_DELETE.FAILURE, error });
    }
}



// WEBPACK FOOTER //
// ./src/sagas/envelope.js